// grid-entry-systems products (10 items)
export const productsGridEntry = [
  {
    id: 8,
    slug: "snap-trax-plus",
    name: "Snap Trax Plus",
    variant: "Entry Grid System",
    type: "Entry Grid System",
    category: "Entry Systems",

    categoryId: "grid-entry-systems",    productSheetPdf: "/Assets/pdf/snap-trax-plus/PS_ISS_SnapTrax_PlusTile.pdf",
    techSpecsPdf: "/Assets/pdf/snap-trax-plus/PS_TechSpecs_SnapTraxPlus.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_12_icon.svg",
    colorCount: 4,
    sizeFormat: "Modular Grid",
    zones: [2, 3],
      industries: ["Corporate Offices", "Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores", "Fitness Centers & Gymnasiums"],
      colorTones: ["black", "charcoal", "brown"],
      patterns: ["textured", "modern"],
      budgetLevels: ["economy", "mid-range"],
    image: "/Assets/images/products/snap-trax-plus/grocery_vestibule.jpg",
    heroImage: "/Assets/images/products/Snap-Trax/SnapTrax_hero-img.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" }
    ],
    comparisonSpecs: {
      material: "recyclable UV-resistant rubber & vinyl compound",
      construction: "TPE with Nylon Carpet",
      backing: "Drop Through Design",
      thickness: "0.47 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Interlocking tiles, grid system",
      recommendedZone: "Zones 1, 2",
      bestUseCase: "Interior entrways, vestibules"
    },
    keyFeatures: [
      "Interlocking 50 cm × 50 cm tiles",
      "Will not shrink or gap",
      "Integrated canals that allow dirt and debris to fall through"
    ],
    gallery: [
      "/Assets/images/new-product-imgs/Snap-Trax-Plus/snap-trax-plus_02.jpg",
      "/Assets/images/products/snap-trax-plus/installation_vestibule.jpg",
      "/Assets/images/products/snap-trax-plus/recessed_tile_entry.jpg",
      "/Assets/images/products/snap-trax-plus/snap_trax_weis_grocery_wide.jpg",
      "/Assets/images/products/snap-trax-plus/snap_trax_weis_vestibule.jpg"
    ],
    swatches: [
      { name: "Dark Grey (Stocked)", image: "/Assets/images/products/Snap-Trax-plus/SnapTrax_DarkGrey_01.jpg" },
      { name: "Black (Custom)", image: "/Assets/images/products/Snap-Trax-plus/SnapTrax_Black_01.jpg" },
      { name: "Brown (Custom)", image: "/Assets/images/products/Snap-Trax-plus/SnapTrax_Brown_01.jpg" },
      { name: "Grey (Custom)", image: "/Assets/images/products/Snap-Trax-plus/SnapTrax_Grey_01.jpg" }
    ],
    isPlaceholder: false,
    description: "Snap Trax helps you keep entryways cleaner, safer, and more controlled, no matter what the traffic. When dirt, moisture, and debris are constantly tracked inside, you need an entry system that actively scrapes and dries footwear before it becomes a problem. That's why Snap Trax is engineered with an enhanced drying and scraping system that removes dirt and debris at the door. Built from a recyclable, UV-resistant TPE/PVC vinyl compound, Snap Trax delivers long-term performance while remaining dimensionally stable, so it won't shrink, gap, or shift over time. Designed as a modular system, Snap Trax tiles can be expanded, customized, and combined to meet the exact needs of any vestibule, even in high-shear, high-load environments.",
    features: [
      "Interlocking 50 cm × 50 cm tiles",
      "Will not shrink or gap",
      "Integrated canals that allow dirt and debris to fall through"
    ],
    specifications: {
      type: "MODULAR GRID SYSTEM WITH CARPET",
      material: "TPE/PVC with Nylon Carpet"
    }
  },
  {
    id: 12,
    slug: "snap-trax-tile",
    name: "Snap Trax Tile",
    variant: "Entry Grid System",
    type: "Entry Grid System",
    category: "Entry Systems",

    categoryId: "grid-entry-systems",    productSheetPdf: "/Assets/pdf/snap-trax-tile/PS_ISS_SnapTrax_Tile.pdf",
    techSpecsPdf: "/Assets/pdf/snap-trax-tile/PS_TechSpecs_SnapTraxTile.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_12_icon.svg",
    colorCount: 1,
    sizeFormat: "Tiles",
    zones: [2, 3],
      industries: ["Corporate Offices", "Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores", "Fitness Centers & Gymnasiums"],
      colorTones: ["black"],
      patterns: ["textured", "modern"],
      budgetLevels: ["economy", "mid-range"],
    image: "/Assets/images/products/Snap-Trax/snaptrax_thumbnail.jpg",
    heroImage: "/Assets/images/products/Snap-Trax/SnapTrax_hero-img.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" },
      { src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use" }
    ],
    comparisonSpecs: {
      material: "recyclable UV-resistant rubber & vinyl compound",
      construction: "100% TPE",
      backing: "Drop Through Deisgn",
      thickness: "0.43 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Interlocking tiles, grid system",
      recommendedZone: "Zones 1, 2",
      bestUseCase: "Interior entrways, vestibules"
    },
    keyFeatures: [
      "Modular interlocking entry system",
      "Scrapes and controls dirt at the door",
      "Dimensionally stable - will not shrink or gap"
    ],
    gallery: [
      "/Assets/images/products/Snap-Trax/SnapTrax_hero-img.jpg",
      "/Assets/images/new-product-imgs/Snap-Trax-Tile/Snap-Trax-tile_02.jpg",
      "/Assets/images/new-product-imgs/Snap-Trax-Tile/snap-trax-tile_03.jpg",
      "/Assets/images/new-product-imgs/Snap-Trax-Tile/snap-trax-tile_04.jpg",
      "/Assets/images/new-product-imgs/Snap-Trax-Tile/snap-trax-tile_05.jpg"
    ],
    swatches: [
      { name: "Black", image: "/Assets/images/products/Snap-Trax/SnapTrax_Vinyl_Black.jpg" }
    ],
    isPlaceholder: false,
    description: "Snap Trax Tile helps you stop dirt, mud, and moisture at the door, before they enter your building. When foot traffic constantly brings debris inside, you need an entry system that actively scrapes and controls contamination while staying firmly in place. That's why Snap Trax Tile is engineered as a modular, interlocking entry system that effectively removes dirt and initial moisture before it spreads indoors. Made from recyclable, UV-resistant 100% TPE, this dimensionally stable tile will not shrink or gap, delivering consistent performance even in demanding environments. Designed for high-traffic vestibules, Snap Trax offers flexibility, strength, and long-term reliability in one integrated system.",
    features: [
      "Interlocking 50cm x 50cm tiles",
      "Additional Clip to keep in place"
    ],
    specifications: {
      construction: "Rugged 100% TPE construction capable of handling 1,000 lb. rolling loads",
      design: "Large open areas",
      material: "Dimensionally stable TPE compound"
    }
  },
  {
    id: 13,
    slug: "s-trax-plus",
    name: "S-Trax Plus",
    variant: "Entry Grid System",
    type: "Entry Grid System",
    category: "Entry Systems",

    categoryId: "grid-entry-systems",    productSheetPdf: "/Assets/pdf/s-trax-plus/PS_InfoSales_STrax_Plus.pdf",
    techSpecsPdf: "/Assets/pdf/s-trax-plus/PS_TechSpecs_STraxPlus.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_12_icon.svg",
    colorCount: 1,
    sizeFormat: "Modular Grid",
    zones: [2, 3],
      industries: ["Corporate Offices", "Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores", "Fitness Centers & Gymnasiums"],
      colorTones: ["charcoal"],
      patterns: ["textured", "modern"],
      budgetLevels: ["economy", "mid-range"],
    image: "/Assets/images/products/s-trax-plus/strax_michaels_thumbnail.jpg",
    heroImage: "/Assets/images/products/S-Trax/S-Trax_hero-img.jpeg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" }
    ],
    comparisonSpecs: {
      material: "Grid PVC / carpet- PA 6 Tufted Nylon",
      construction: "Ribbed PVC/Tufted Carpet",
      backing: "Drop Through Deisgn",
      thickness: "0.5625 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Interlocking tiles, grid system",
      recommendedZone: "Zones 1, 2",
      bestUseCase: "Interior entrways, vestibules"
    },
    keyFeatures: [
      "Sleek, linear finish with high visual appeal",
      "Low maintenance interlocking tile system",
      "Handles heavy foot and wheeled traffic"
    ],
    gallery: [
      "/Assets/images/products/s-trax-plus/strax_inside_store.jpg",
      "/Assets/images/products/s-trax-plus/michaels_toledo_casestudy.jpg",
      "/Assets/images/products/s-trax-plus/michaels_vestibule2.jpg",
      "/Assets/images/products/s-trax-plus/strax_michaels_toledo2.jpg",
      "/Assets/images/products/s-trax-plus/strax_michaels_vestibule_view.jpg"
    ],
    swatches: [
      { name: "Standard", image: "/Assets/images/products/S-Trax/S-Trax_Plus_.jpg" }
    ],
    isPlaceholder: false,
    description: "S-Trax Plus delivers a sleek, linear finish that's both visually appealing and built to perform. This durable interlocking vinyl tile system, paired with nylon carpet strips, creates an entryway solution that's high on style and low on maintenance. Engineered to withstand heavy foot and wheeled traffic, S-Trax Plus outperforms traditional matting systems by effectively removing debris and moisture while maintaining its appearance over time.",
    features: [
      "Interlocking 50cm x 50cm tiles allow versatility",
      "Patent pending locking clip to keep grids in place",
      "Effectively scrapes shoes and dries foot traffic"
    ],
    specifications: {
      type: "MODULAR GRID SYSTEM",
      carpetGridComposition: { label: "Carpet/Grid Composition", value: "Tufted Carpet/Ribbed vinyl" },
      loadCapacity: "Capable of handling 1,000 lb. rolling load"
    }
  },
  {
    id: 19,
    slug: "2n1-grid-entry",
    name: "2-N-1",
    variant: "Entry Grid System",
    type: "Entry Grid System",
    category: "Entry Systems",

    categoryId: "grid-entry-systems",    productSheetPdf: "/Assets/pdf/2n1-grid-entry/PS_ISS_TwoNOneMat.pdf",
    techSpecsPdf: "/Assets/pdf/2n1-grid-entry/PS_TechSpecs_2n1.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_12_icon.svg",
    colorCount: 1,
    sizeFormat: "Custom",
    zones: [1, 2],
      industries: ["Corporate Offices", "Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores", "Fitness Centers & Gymnasiums"],
      colorTones: ["black", "charcoal"],
      patterns: ["textured", "modern"],
      budgetLevels: ["mid-range", "premium"],
    image: "/Assets/images/products/2n1-ges/2n1_-(1).jpg",
    heroImage: "/Assets/images/products/2n1-ges/2n1_-(1).jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" },
      { src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use" }
    ],
    comparisonSpecs: {
      material: "PVC (Ribbed Grid) + ASOTA® polypropylene",
      construction: "Hybrid",
      backing: "Flexible PVC + Premium Composite Rubber",
      thickness: "0.5 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat",
      recommendedZone: "Zones 1, 2",
      bestUseCase: "Out/inside entrways, vestibules"
    },
    keyFeatures: [
      "Grid Material is Flexible PVC (Ribbed Grid)",
      "Carpet Fiber is 100% Solution-dyed, UV stabilized polypropylene",
      "Custom logo capabilities for the carpet section"
    ],
    gallery: [
      "/Assets/images/products/2n1-ges/2n1_college_dorm.jpg",
      "/Assets/images/products/2n1-ges/2n1_-(1).jpg",
      "/Assets/images/products/2n1-ges/2n1_product_studio.jpg",
      "/Assets/images/products/2n1-ges/2n1_brown.jpg",
      "/Assets/images/products/2n1-ges/2n1_ny_life_lobby.jpg"
    ],
    swatches: [],
    isPlaceholder: false,
    description: [
      "If you're responsible for designing or maintaining a high-traffic space, you need an entrance solution that performs under pressure while still supporting your brand and design vision. The problem is that many entry systems either lack durability in busy environments or limit your creative flexibility.",
      "Two-n-One is manufactured using Portico Systems' industry-leading assembly process and built specifically for medium to high traffic environments. Available in a wide range of shapes, sizes, and colors—including single-tone, custom logo designs, or semi-permanent wall-to-wall installations."
    ],
    features: [
      "Grid Material is Flexible PVC (Ribbed Grid)",
      "Carpet Fiber is 100% Solution-dyed, UV stabilized polypropylene",
      "Custom logo capabilities for the carpet section"
    ],
    specifications: {
      trafficRating: "Made for medium to high traffic environments",
      hybrid: "Hybrid matting offers the performance of a full entry system"
    }
  },
  {
    id: 23,
    slug: "frontrunner-entry",
    name: "Frontrunner",
    variant: "Entry Grid System",
    type: "Entry Grid System",
    category: "Entry Systems",

    categoryId: "grid-entry-systems",    productSheetPdf: "/Assets/pdf/frontrunner-entry/PS_ISS_Frontrunner.pdf",
    techSpecsPdf: "/Assets/pdf/frontrunner-entry/PS_TechSpecs_Frontrunner.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_12_icon.svg",
    colorCount: 3,
    sizeFormat: "Rolls",
    zones: [1, 2],
      industries: ["Corporate Offices", "Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores", "Fitness Centers & Gymnasiums"],
      colorTones: ["black", "grey", "brown"],
      patterns: ["textured", "modern"],
      budgetLevels: ["economy", "mid-range"],
    image: "/Assets/images/products/frontrunner/Frontrunner-Reg_thumbnail.jpg",
    heroImage: "/Assets/images/products/frontrunner/Frontrunner-Reg_hero.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" },
      { src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use" }
    ],
    comparisonSpecs: {
      material: "Flexible PVC",
      construction: "interlocking grid",
      backing: "Drop Through Deisgn",
      thickness: "0.563 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Grid System",
      recommendedZone: "Zones 1, 2",
      bestUseCase: "Out/inside entrways, vestibules"
    },
    keyFeatures: [
      "Frontrunner is made from a hard-wearing, flexible PVC",
      "Wheeled traffic friendly including shopping trolleys",
      "Open grid design lets debris fall through"
    ],
    gallery: [
      "/Assets/images/products/frontrunner/frontrunner_retail.jpg",
      "/Assets/images/products/frontrunner/frontrunner_vestibule.jpg",
      "/Assets/images/products/frontrunner/Frontrunner-Reg_-(2).jpg",
      "/Assets/images/products/frontrunner/Frontrunner_Entry_display.jpg",
      "/Assets/images/products/frontrunner/Frontrunner_GreyDisplay.jpg",
      "/Assets/images/products/frontrunner/frontrunner_galeries_lafayette_rooftop.jpg",
      "/Assets/images/products/frontrunner/frontrunner_recessed_install.jpg"
    ],
    swatches: [
      { name: "Black", image: "/Assets/images/products/frontrunner/Swatches/Black.jpg" },
      { name: "Brown", image: "/Assets/images/products/frontrunner/Swatches/Brown.jpg" },
      { name: "Grey", image: "/Assets/images/products/frontrunner/Swatches/Grey.jpg" }
    ],
    isPlaceholder: false,
    description: [
      "If you manage a high-traffic entrance, you need a flooring system that is safe for everyone whether they're wearing heels, using wheelchairs, or pushing shopping carts. The problem is that many entrance systems create gaps that trap heels, restrict wheeled access, or make cleaning difficult.",
      "Frontrunner is designed with a special close-space open grid structure that is heel-proof and fully suitable for wheelchairs, shopping trolleys, and other wheel traffic. Made from hard-wearing, flexible PVC and supplied in convenient roll formats."
    ],
    features: [
      "Made from hard-wearing, flexible PVC",
      "Wheeled traffic friendly",
      "Open grid design lets debris fall through"
    ],
    specifications: {
      material: "Flexible PVC",
      profile: "Available in regular & Low-Profile"
    }
  },
  {
    id: 24,
    slug: "frontrunner-plus",
    name: "Frontrunner Plus",
    variant: "Entry Grid System",
    type: "Entry Grid System",
    category: "Entry Systems",

    categoryId: "grid-entry-systems",    productSheetPdf: "/Assets/pdf/frontrunner-plus/PS_ISS_FrontrunnerPlus.pdf",
    techSpecsPdf: "/Assets/pdf/frontrunner-plus/PS_TechSpecs_FrontrunnerPlus.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_23_icon.svg",
    colorCount: 3,
    sizeFormat: "Rolls",
    zones: [1, 2],
      industries: ["Corporate Offices", "Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores", "Fitness Centers & Gymnasiums"],
      colorTones: ["black", "grey"],
      patterns: ["textured", "modern"],
      budgetLevels: ["economy", "mid-range"],
    image: "/Assets/images/products/frontrunner-plus/FRPlus_thumbnail.jpg",
    heroImage: "/Assets/images/products/frontrunner-plus/FRPlus_hero.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" }
    ],
    comparisonSpecs: {
      material: "Flexible PVC",
      construction: "Hybrid",
      backing: "Drop Through Design",
      thickness: "0.625 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Grid System",
      recommendedZone: "Zones 1, 2",
      bestUseCase: "Interior entrways, vestibules"
    },
    keyFeatures: [
      "Frontrunner Plus is made from a hard-wearing, flexible PVC",
      "Wheeled traffic friendly including shopping trolleys",
      "Open grid design lets debris fall through"
    ],
    gallery: [
      "/Assets/images/products/frontrunner/Frontrunner-Reg_hero.jpg",
      "/Assets/images/products/frontrunner-plus/FRPlus_-(1).jpg",
      "/Assets/images/products/frontrunner-plus/FRPlus_-(3).jpg",
      "/Assets/images/products/frontrunner-plus/Frontrunner_Plus_display.jpg",
      "/Assets/images/products/frontrunner-plus/frplus_grocery_entry.jpg",
      "/Assets/images/products/frontrunner-plus/frplus_grocery_lobby.jpg",
      "/Assets/images/products/frontrunner-plus/frplus_retail_angled_install.jpg"
    ],
    swatches: [
      { name: "Black vinyl with Smoke 608 carpet", image: "/Assets/images/products/frontrunner-plus/Swatches/Black-vinyl-with-Smoke-608-carpet.jpg" },
      { name: "Brown LP vinyl with Coffee Bean 605 carpet", image: "/Assets/images/products/frontrunner-plus/Swatches/Brown-LP-vinyl-with-Coffee-Bean-605-carpet.jpg" },
      { name: "Grey LP vinyl with Steel Grey 606 carpet", image: "/Assets/images/products/frontrunner-plus/Swatches/Grey-LP-vinyl-with-Steel-Grey-606-carpet.jpg" }
    ],
    isPlaceholder: false,
    description: [
      "If you manage a high-traffic entrance, you need a flooring system that is safe for everyone whether they're wearing heels, using wheelchairs, or pushing shopping carts. The problem is that many entrance systems create gaps that trap heels, restrict wheeled access, or make cleaning difficult.",
      "Frontrunner Plus is designed with a special close-space open grid structure that is heel-proof and fully suitable for wheelchairs, shopping trolleys, and other wheel traffic. The primary backing is Colback non-woven polyester & comfort vinyl."
    ],
    features: [
      "Made from hard-wearing, flexible PVC",
      "Wheeled traffic friendly",
      "Open grid design lets debris fall through"
    ],
    specifications: {
      material: "Flexible PVC",
      backing: "Colback non-woven polyester & comfort vinyl"
    }
  },
  {
    id: 25,
    slug: "frontrunner-sb",
    name: "Frontrunner SB",
    variant: "Entry Grid System",
    type: "Entry Grid System",
    category: "Entry Systems",

    categoryId: "grid-entry-systems",    productSheetPdf: "/Assets/pdf/frontrunner-sb/PS_ISS_FrontrunnerSB.pdf",
    techSpecsPdf: "/Assets/pdf/frontrunner-sb/PS_TechSpecs_FrontrunnerSB.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_12_icon.svg",
    colorCount: 2,
    sizeFormat: "Rolls",
    zones: [2, 3],
      industries: ["Corporate Offices", "Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores", "Fitness Centers & Gymnasiums"],
      colorTones: ["black", "grey", "brown"],
      patterns: ["textured", "modern"],
      budgetLevels: ["economy", "mid-range"],
    image: "/Assets/images/products/frontrunner-sb/FR-SB-(1).jpg",
    heroImage: "/Assets/images/products/frontrunner-sb/Frontrunner_SB_display.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" },
      { src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use" }
    ],
    comparisonSpecs: {
      material: "Flexible PVC",
      construction: "ribbed pvc roll",
      backing: "Non Drop Through Design",
      thickness: "0.25 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Grid System",
      recommendedZone: "Zones 1, 2",
      bestUseCase: "Interior entrways, vestibules"
    },
    keyFeatures: [
      "Suitable for heavy traffic areas",
      "Wheeled traffic friendly including shopping trolleys",
      "Open grid design lets debris fall through"
    ],
    gallery: [
      "/Assets/images/products/frontrunner-sb/FR-SB-(1).jpg",
      "/Assets/images/products/frontrunner-sb/FR-SB-(2).jpg",
      "/Assets/images/products/frontrunner-sb/Frontrunner_SB_display.jpg"
    ],
    swatches: [
      { name: "Black", image: "/Assets/images/products/frontrunner-sb/Swatches/Black.jpg" },
      { name: "Grey", image: "/Assets/images/products/frontrunner-sb/Swatches/Grey.jpg" }
    ],
    isPlaceholder: false,
    description: [
      "If you're responsible for maintaining a clean and safe entrance, you need a system that stops dirt and moisture before they ever reach your interior floors. The problem is that many entry systems allow debris and water to track inside creating slip hazards and increasing maintenance costs.",
      "This system is engineered with a special close-space open grid design that prevents dirt and debris from making their way indoors. When paired with Frontrunner Plus to remove moisture, it delivers permanent entrance protection that is both highly durable and certified slip resistant."
    ],
    features: [
      "Flexible PVC material",
      "Standard Roll length 33ft",
      "Suitable for heavy traffic areas"
    ],
    specifications: {
      material: "Flexible PVC",
      rollLength: "Standard Roll length 33ft"
    }
  },
  {
    id: 26,
    slug: "frontrunner-sb-plus",
    name: "Frontrunner Plus SB",
    variant: "Entry Grid System",
    type: "Entry Grid System",
    category: "Entry Systems",

    categoryId: "grid-entry-systems",    productSheetPdf: "/Assets/pdf/frontrunner-sb-plus/PS_ISS_FrontrunnerPlus_SB.pdf",
    techSpecsPdf: "/Assets/pdf/frontrunner-sb-plus/PS_TechSpecs_FrontrunnerPlus_SB.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_23_icon.svg",
    colorCount: 1,
    sizeFormat: "Rolls",
    zones: [2, 3],
      industries: ["Corporate Offices", "Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores", "Fitness Centers & Gymnasiums"],
      colorTones: ["black"],
      patterns: ["textured", "modern"],
      budgetLevels: ["economy", "mid-range"],
    image: "/Assets/images/products/frontrunner-sb-plus/FR-SB+_thumbnail.jpg",
    heroImage: "/Assets/images/products/frontrunner-sb-plus/FR-SB+_hero.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" }
    ],
    comparisonSpecs: {
      material: "Flexible PVC",
      construction: "Carpeted Solid-Backed Quiet Vinyl Grid",
      backing: "Solid-Backed Vinyl",
      thickness: "0.315 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Grid System",
      recommendedZone: "Zones 1, 2",
      bestUseCase: "Interior entrways, vestibules"
    },
    keyFeatures: [
      "Frontrunner Plus SB is made from a hard-wearing, flexible PVC",
      "Wheeled traffic friendly including shopping trolleys",
      "Solid-backed design prevents dirt from passing through"
    ],
    gallery: [
      "/Assets/images/products/frontrunner-sb-plus/frsbp_rushden_lakes_3.jpg",
      "/Assets/images/products/frontrunner-sb-plus/frsbp_rushden_lakes_7.jpg",
      "/Assets/images/products/frontrunner-sb-plus/FR-SB+_hero.jpg",
      "/Assets/images/products/frontrunner-sb-plus/FR-SB+_-(1).jpg",
      "/Assets/images/products/frontrunner-sb-plus/FR-SB+_-(2).jpg",
      "/Assets/images/products/frontrunner-sb-plus/Frontrunner_SB_Plus_display.jpg"
    ],
    swatches: [
      { name: "Black vinyl with Smoke 608 carpet", image: "/Assets/images/products/frontrunner-sb-plus/Swatches/Black-vinyl-with-Smoke-608-carpet.jpg" }
    ],
    isPlaceholder: false,
    description: [
      "If you're responsible for keeping your building clean and safe, you need an entrance system that stops debris and moisture before they spread throughout your space. The problem is that many entry systems allow dirt to fall through or water to linger.",
      "This system delivers all the performance benefits of Frontrunner Plus, now with an added solid-backed design to prevent dirt from passing through and contaminating the surrounding area. When used in conjunction with Frontrunner Plus to remove moisture, it provides permanent entrance protection."
    ],
    features: [
      "Well proven first barrier to prevent dirt from entering buildings",
      "Carpeted solid-backed design",
      "Wheeled traffic friendly"
    ],
    specifications: {
      material: "Hard-wearing, flexible PVC",
      design: "Carpeted solid-backed"
    }
  },
  {
      id: 50,
      slug: "heron-rib-ges",
      name: "Heron Rib",
      variant: "Grid Entry System",
      type: "Grid Entry System",
      category: "Entry Systems",

    categoryId: "grid-entry-systems",
      productSheetPdf: "/Assets/pdf/heron-rib-ges/PS_InfoSales_HeronRib.pdf",
    techSpecsPdf: "/Assets/pdf/heron-rib-ges/PS_TechSpecs_HeronRib.pdf",
      saleSheetPdf: "/Assets/pdf/heron-rib-ges/PS_ISS_HeronRib.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
      colorCount: 6,
      sizeFormat: "Custom",
      zones: [3],
      industries: ["Grocery & Convenience Stores", "Hospitality Sector", "Educational Institutions", "Specialty Stores", "Fitness Centers & Gymnasiums"],
      colorTones: ["charcoal", "blue", "green", "red", "neutral"],
      patterns: ["textured", "modern"],
      budgetLevels: ["mid-range", "premium"],
      image: "/Assets/images/products/heron-rib-ges/heron-rib-ges_thumbnail.jpg",
      heroImage: "/Assets/images/products/heron-rib-ges/heron-rib-ges_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"}
      ],
    comparisonSpecs: {
      material: "Flexible Polyvinyl Chloride",
      construction: "Rubber compounding and calendaring/extrusion process",
      backing: "Drop Through Design",
      thickness: "0.40625 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "roll goods grid system",
      recommendedZone: "Zone 3",
      bestUseCase: "Pools and Locker rooms"
    },
      keyFeatures: ["Perfect for extensive barefoot traffic", "UV resistant"],
      gallery: ["/Assets/images/products/heron-rib-ges/heron-rib-ges_hero.jpg", "/Assets/images/products/heron-rib-ges/heronrib_sauna_corridor.jpg", "/Assets/images/products/heron-rib-ges/heronrib_shower_locker_room.jpg", "/Assets/images/products/heron-rib-ges/heronrib_plastex_5.jpg", "/Assets/images/products/heron-rib-ges/heronrib_plastex_22.jpg"],
      swatches: [
        {name: "Charcoal Grey", image: "/Assets/images/products/heron-rib-ges/swatches/Charcoal-Grey.jpg"},
        {name: "Forest Green", image: "/Assets/images/products/heron-rib-ges/swatches/Forest-Green.jpg"},
        {name: "Ocean Blue", image: "/Assets/images/products/heron-rib-ges/swatches/Ocean-Blue.jpg"},
        {name: "White", image: "/Assets/images/products/heron-rib-ges/swatches/White.jpg"},
        {name: "Oxford Blue", image: "/Assets/images/products/heron-rib-ges/swatches/Oxford-Blue.jpg"},
        {name: "Mulberry Red", image: "/Assets/images/products/heron-rib-ges/swatches/Mulberry-Red.jpg"}
      ],
      isPlaceholder: false,
      description: "Wet areas demand flooring that manages water effectively while providing secure footing. Heron Rib is engineered with strong, non-porous PVC and channeled underbars that allow water to drain quickly—even in environments with constant moisture. The embossed ribbed surface enhances grip for barefoot traffic, helping reduce slips around pools, saunas, spas, and other wet zones. Its flexible construction easily contours to uneven surfaces and can be cut to fit custom spaces, delivering a durable, UV-resistant flooring solution designed for high-moisture leisure and sports environments.",
      features: ["Perfect for extensive barefoot traffic", "UV resistant"],
      specifications: {}
    },
  {
      id: 51,
      slug: "heron-tile-ges",
      name: "Heron Tile",
      variant: "Grid Entry System",
      type: "Grid Entry System",
      category: "Entry Systems",

    categoryId: "grid-entry-systems",
      productSheetPdf: "/Assets/pdf/heron-tile-ges/PS_InfoSales_HeronTile.pdf",
    techSpecsPdf: "/Assets/pdf/heron-tile-ges/PS_TechSpecs_HeronTile.pdf",
      saleSheetPdf: "/Assets/pdf/heron-tile-ges/PS_ISS_HeronTile.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
      colorCount: 4,
      sizeFormat: "Custom",
      zones: [2, 3],
      industries: ["Grocery & Convenience Stores", "Hospitality Sector", "Educational Institutions", "Specialty Stores", "Fitness Centers & Gymnasiums"],
      colorTones: ["grey", "blue", "beige"],
      patterns: ["textured", "modern"],
      budgetLevels: ["mid-range", "premium"],
      image: "/Assets/images/products/heron-tile-ges/heron-tile-ges_thumbnail.jpg",
      heroImage: "/Assets/images/products/heron-tile-ges/heron-tile-ges_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"}
      ],
    comparisonSpecs: {
      material: "Flexible PVC",
      construction: "heated hydraulic press",
      backing: "homogeneous rubber tile",
      thickness: "0.625 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Interlocking Tiles",
      recommendedZone: "Zone 3",
      bestUseCase: "Locker rooms"
    },
      keyFeatures: ["Tiles easily click into place for simple installation", "Ease cleaning with excellent drainage"],
      gallery: ["/Assets/images/products/heron-tile-ges/heron-tile-ges_hero.jpg", "/Assets/images/products/heron-tile-ges/herontile_pool_corner.jpg", "/Assets/images/products/heron-tile-ges/herontile_locker_room.jpg"],
      swatches: [
        {name: "Beige", image: "/Assets/images/products/heron-tile-ges/swatches/Beige.jpg"},
        {name: "Ocean Blue", image: "/Assets/images/products/heron-tile-ges/swatches/Ocean-Blue.jpg"},
        {name: "Light Blue", image: "/Assets/images/products/heron-tile-ges/swatches/Light-Blue.jpg"},
        {name: "Light Grey", image: "/Assets/images/products/heron-tile-ges/swatches/Light-Grey.jpg"}
      ],
      isPlaceholder: false,
      description: "In wet environments where safety and comfort are essential, flooring must provide secure footing and reliable drainage. Heron Tile is designed to support barefoot traffic in areas like pools, gyms, and leisure facilities. Made from resilient EVA material and standing 5/8\" thick, the tiles offer cushioned comfort underfoot while allowing water to drain away efficiently. The embossed surface enhances grip, and built-in antimicrobial and antifungal additives help maintain hygiene. With interlocking tiles that are installed quickly and create seamless coverage, Heron Tile delivers a practical flooring solution for active wet areas.",
      features: ["Tiles easily click into place for simple installation", "Ease cleaning with excellent drainage"],
      specifications: {}
    },
];
